import {pullQtys, pullCategories} from "../../data/Ingredient/ingredientData";

export const UpdateQtyTypes = "UPDATEQTYTYPES";
export const UpdateCategories = "UPDATECATEGORIES";
export const UpdateUser = "UPDATEUSER"
export const Nav = "NAV"
export const screenSetter = "SCREENSETTER";
export const recipeUser = "RECIPEUSER";
export const RECIPE = "RECIPE"
export const USER = "USER"

export async function asyncInitGlobalState(dispatcher) {
    await pullQtys().then(x => dispatcher({type: UpdateQtyTypes, payload: x}))
    await pullCategories().then(x => {
        // Convert array to object keyed by name for easy lookup
        const categoriesMap = {};
        if (x) {
            x.forEach(cat => {
                categoriesMap[cat.name] = { displayName: cat.displayName, order: cat.order };
            });
        }
        dispatcher({type: UpdateCategories, payload: categoriesMap});
    })
}

export async function setUser(user, dispatcher) {
    await dispatcher({type: UpdateUser, payload: user})
}

export async function setGlobalRecipe(dispatcher, recipeOrUser) {
    await dispatcher({type: recipeUser, payload: RECIPE})
}
export async function setGlobalUser(dispatcher, recipeOrUser) {
    await dispatcher({type: recipeUser, payload: USER})
}


const initialState = {
    page: undefined,
    recipeUser: "RECIPE",
    mobileScreen: false,
    qtyTypes: [],
    ingredientCategories: {},
    user: undefined
};

export default function globalReducer(state = initialState, action) {
    switch (action.type) {
        case recipeUser:{
            return {
                ...state,
                recipeUser: action.payload
            }
        }
        case screenSetter: {
            return {
                ...state,
                mobileScreen: action.payload
            }
        }
        case UpdateQtyTypes: {
            return {
                ...state,
                qtyTypes: action.payload
            };
        }
        case UpdateCategories: {
            return {
                ...state,
                ingredientCategories: action.payload
            };
        }
        case UpdateUser: {
            return {
                ...state,
                user: action.payload,
            };
        }
        case Nav: {
            return {
                ...state,
                page: action.payload
            }
        }
        default:
            return state;
    }
}
